import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TimeAgoAsyncPipe } from '@core/time-legacy';

import { SummaryEvaluationMeterComponent } from '../candidate-profile-placement/evaluation-meter/summary-evaluation-meter.component';

@Component({
  selector: 'rt-interview-results-summary-chart',
  imports: [TranslatePipe, TimeAgoAsyncPipe, SummaryEvaluationMeterComponent],
  templateUrl: './interview-results-summary-chart.component.html',
  styleUrls: ['./interview-results-summary-chart.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterviewResultsSummaryChartComponent {
  public readonly positiveRatings = input<number>(undefined!);
  public readonly evaluationTranslationKey = input<string>('app.interview.average_score');
  public readonly totalRatings = input<number>(undefined!);
  public readonly uniqAdmins = input<number>(undefined!);
  @Input() public lastUpdate: string | null = null;
}
